import { render, staticRenderFns } from "./CategoryUserList.vue?vue&type=template&id=da1ca85c&"
import script from "./CategoryUserList.vue?vue&type=script&lang=ts&"
export * from "./CategoryUserList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports